import { Component, Input, ChangeDetectionStrategy} from '@angular/core';
import { IndicatorNaamPrestatieanalyse } from '@cumlaude/metadata';
import { percentiel_obv_normaal } from '../../../services/percentiel';
import { formatPercent } from '@angular/common';
import { TooltipDirective, TooltipElement } from '@cumlaude/shared-components-overlays';
import { SinglePercentielHbarComponent } from '../single-percentiel-hbar/single-percentiel-hbar.component';
import { formatDecimal } from '@cumlaude/shared-pipes';

export interface PrestatieanalyseCellData {
	pv_nm_indicator: IndicatorNaamPrestatieanalyse;
	pv_m_nr_score: number | null;
	p25_p75: [number, number] | null;
	tooltip: TooltipElement[];
	is_onvoldoende: boolean;
}

@Component({
	selector: 'app-card-pa-cell',
	templateUrl: './card-pa-cell.component.html',
	styleUrls: ['./card-pa-cell.component.scss'],
	imports: [TooltipDirective, SinglePercentielHbarComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardPaCellComponent {
	@Input()
	data!: PrestatieanalyseCellData;

	getScore() {
		const { pv_m_nr_score, pv_nm_indicator } = this.data;
		if (pv_m_nr_score === null) return '';

		if (pv_nm_indicator === IndicatorNaamPrestatieanalyse.BEOOGD_I_R_T_BEHAALD_EINDUITSTROOMNIVEAU) {
			return formatDecimal(pv_m_nr_score, '1.2-2');
		}

		return formatPercent(pv_m_nr_score / 100, 'nl_NL', '1.0-0');
	}

	getPercentielBarData() {
		const { pv_m_nr_score, p25_p75, pv_nm_indicator } = this.data;
		if (pv_m_nr_score == null || p25_p75 == null) return null;
		const percentiel = percentiel_obv_normaal(pv_m_nr_score, ...p25_p75);
		return {
			heightPx: 24,
			widthPx: 64,
			percentiel,
			// Voor beoogd irt behaald einduitstroomniveau is een hogere score slechter, dus kleuren we de balk omgekeerd
			invertColors: pv_nm_indicator === IndicatorNaamPrestatieanalyse.BEOOGD_I_R_T_BEHAALD_EINDUITSTROOMNIVEAU,
		};
	}
}
